'use client';
import { IconFlagAR, IconFlagEN } from '@/shared/assets/icons';

export const LANGUAGES_ICON_MAPPER = {
  en: <IconFlagEN />,
  ar: <IconFlagAR />,
} as const;

export type AvailableLangs = keyof typeof LANGUAGES_ICON_MAPPER; // 'en' | 'ar'
